// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.notifications.RentalManagerUserNotificationsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserNotificationsWebApiHandler_allNotifications,
  RentalManagerUserNotificationsWebApiHandler_allNotifications_Path,
  RentalManagerUserNotificationsWebApiHandler_markAllAsRead,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { UserNotificationsAllNotificationsResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

interface AllNotificationsParams {
  includeHasNewNotificationsForNotificationCenter?: boolean;
  limit?: number;
  start?: number;
}

export type RentalManagerUserNotificationsWebApiHandler_allNotifications_Options = UseQueryOptions<
  UserNotificationsAllNotificationsResponseWebDto,
  unknown,
  UserNotificationsAllNotificationsResponseWebDto,
  readonly [string, AllNotificationsParams]
>;

const RentalManagerUserNotificationsWebApiHandler_allNotifications_GetKey = (getParams: AllNotificationsParams) =>
  [RentalManagerUserNotificationsWebApiHandler_allNotifications_Path, getParams] as const;

export const RentalManagerUserNotificationsWebApiHandler_allNotifications_queryOptions = (
  getParams: AllNotificationsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserNotificationsWebApiHandler_allNotifications_GetKey(getParams),
    queryFn: () => RentalManagerUserNotificationsWebApiHandler_allNotifications(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get all notifications of a user
 */
export const useRentalManagerUserNotificationsWebApiHandler_allNotifications = (
  getParams: AllNotificationsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserNotificationsWebApiHandler_allNotifications_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserNotificationsWebApiHandler_allNotifications_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserNotificationsWebApiHandler_allNotifications.getKey =
  RentalManagerUserNotificationsWebApiHandler_allNotifications_GetKey;

export type RentalManagerUserNotificationsWebApiHandler_markAllAsRead_Options = UseMutationOptions<void, unknown, void>;

/**
 * Mark all notifications as read
 */
export const useRentalManagerUserNotificationsWebApiHandler_markAllAsRead = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserNotificationsWebApiHandler_markAllAsRead_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => RentalManagerUserNotificationsWebApiHandler_markAllAsRead(httpClient),
  });
};
